module.exports = __webpack_public_path__ + "img/Trabalheconosco.b5a1714.png";